<div class="modal-header">
</div>
<div class="modal-body text-center">
    A confirmation email has been sent to your inbox. Please check your email and click the confirmation link to
    proceed. Once confirmed, return to this page to continue.
    <div class="box-spinner">
        <p>waiting..</p>
        <div class="spinner"></div>
    </div>
</div>
<div class="modal-footer">
</div>